export default __webpack_public_path__ + "static/media/logo.839d9634.svg";